import React, { KeyboardEvent, useEffect, useState } from 'react'
import Selector from './../../Components/Select/Select'
import { getReportType } from './../../Service/report'
import { report } from './../../store/report'
import { observer } from 'mobx-react-lite'
import { SelectType } from '../../store/models'
import http from './../../Service/http'
import Input from './../../Components/Select/Input'
import { BsSearch } from 'react-icons/bs'
import { ChangeEvent } from 'react'
import { accountDocs } from './../../store/accountDocs'

function SearchByType() {
	const [text, setText] = useState<string>('')

	const getReport = async () => {
		const result = await http.post('/regis/academDocRegTable', {
			reportType: 0,
			s_fio_document: text
		})
		accountDocs.newDocs(result.data.AcademDocRegTable)
	}
	const downEnter = async (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key == 'Enter') {
			getReport()
		}
	}

	useEffect(() => {
		getReport()
	}, [])

	return (
		<div style={{ margin: '0 auto', width: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
			<Input
				type={'search'}
				value={text}
				oninput={setText}
				placeholder={''}
				title={'Введите'}
				style={{ width: '80%' }}
				keyDown={downEnter}
			/>
			<BsSearch className='search_icon' onClick={getReport} />
		</div>
	)
}

export default SearchByType
